import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazy } from 'react';

const Error401 = lazy(() => import('./Error401Page'));

/**
 * The Error 401 page route.
 */
const Error401Route: FuseRouteItemType = {
    path: '401',
    element: <Error401 />,
    settings: {
        layout: {
            config: {
                toolbar: {
                    showTitle: false,
                    title: '401 - Unauthorized',
                    showCrumbs: false
                }
            }
        }
    }
};

export default Error401Route;
